import React from 'react'
import {Typography} from '@material-ui/core'

import {Query, Mutation} from 'react-apollo'
import {FusePageCarded} from '../../../../../@fuse'
import {requireAuthAndProject} from '../../../../../auth'
import ResponseContent from './ResponseContent'
import {GET_RESPONSE_MESSAGE} from '../../../../../graphql/query'
import {UPDATE_RESPONSE_MESSAGE} from '../../../../../graphql/mutation'

const header = (
  <div className="flex items-center p-8 md:p-24">
    <img
      style={{
        width: '50px',
      }}
      className="text-32 mr-12"
      alt=""
      src="./assets/images/deeple/5_ai_setting_white.png"
    />
    <Typography variant="title">Response Settings</Typography>
  </div>
)

class ResponsePage extends React.Component {
  render() {
    return (
      <FusePageCarded
        header={header}
        content={
          <Query
            query={GET_RESPONSE_MESSAGE}
            variables={{projectId: this.props.project.id}}
          >
            {({loading, error, data}) => {
              if (loading) return 'loading..'
              if (error) return 'error!'
              return (
                <Mutation
                  mutation={UPDATE_RESPONSE_MESSAGE}
                  refetchQueries={[
                    {
                      query: GET_RESPONSE_MESSAGE,
                      variables: {
                        projectId: this.props.project.id,
                      },
                    },
                  ]}
                >
                  {newResponseGQL => {
                    return (
                      <ResponseContent
                        responseMessages={data.getResponseMessage}
                        projectId={this.props.project.id}
                        newResponseGQL={newResponseGQL}
                      />
                    )
                  }}
                </Mutation>
              )
            }}
          </Query>
        }
        innerScroll
      />
    )
  }
}

export default requireAuthAndProject(ResponsePage)



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/responseMessage/ResponsePage.js